import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { EcosystemCard } from '../ecosystem/EcosystemCard';
import { ecosystemEntries } from '../../data/ecosystem';
import { fadeUp } from '../../utils/motion';
export function HomeEcosystem() {
  return <section id="ecosystem" aria-labelledby="ecosystem-title" className="scroll-mt-20 border-t border-line bg-white py-20 lg:py-28" data-id="element-1132" data-mp="32c3imrn6hv52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1133" data-mp="24pxt3izcxepu">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12 lg:mb-14" data-id="element-1134" data-mp="29ng2tbl77xyw">
          <div className="lg:col-span-5" data-id="element-1135" data-mp="2em97ceiicemx">
            <p className="text-sm font-medium text-teal mb-3" data-id="element-1136" data-mp="2elhn1zud23by">Ecosystem</p>
            <h2 id="ecosystem-title" className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-1137" data-mp="2jekh0931veso">
              Our ecosystem
            </h2>
          </div>
          <p className="lg:col-span-7 lg:pt-9 text-xl text-ink-dark leading-relaxed" data-id="element-1138" data-mp="1qv3rw0ghbod5">
            Connecting organizations and initiatives through shared intelligence infrastructure.
          </p>
        </motion.div>

        <motion.ul {...fadeUp} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-1139" data-mp="7fcr85oggzd4">
          {ecosystemEntries.map(entry => <li key={entry.slug} data-id="element-1140" data-mp="2f8col73yepj">
              <EcosystemCard entry={entry} data-id="element-1141" data-mp="2e6zaa2mdg4n" />
            </li>)}
        </motion.ul>

        <motion.a {...fadeUp} href="/ecosystem" className="mt-10 inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1142" data-mp="3uldkqkq0z1nh">
          Explore the ecosystem <ArrowRight size={16} aria-hidden="true" data-id="element-1143" data-mp="1itgmdf6s4tjr" />
        </motion.a>
      </div>
    </section>;
}